var $961ae0833f811705$exports = {};
$961ae0833f811705$exports = {
    "Clear search": `Tyhjenn\xe4 haku`
};


export {$961ae0833f811705$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
